import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const url = import.meta.env.VITE_API_URL;
const timestamp = import.meta.env.VITE_BUILD_TIMESTAMP;

i18next
  .use(XHR) // loads translations from public folder
  .use(LanguageDetector) // detects browser language
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `${url}locales/{{lng}}/translation.json?t=${timestamp}`,
      allowMultiLoading: false,
      crossDomain: false,
    },
    interpolation: {
      escapeValue: false,
      skipOnVariables: false,
    },
    fallbackLng: 'de', // if user's lang is not available
    // debug: process.env.NODE_ENV !== 'production',
    debug: false,
  });

export const i18n = i18next;